module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Resorting_to_Murder2#Contents-A"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Introduction and notes copyright © 2015 Martin Edwards")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("‘Where is Mr Manetot?’ by Phyllis Bentley reprinted by permission of Peters Fraser & Dunlop (www.petersfraserdunlop.com) on behalf of the Estate of Phyllis Bentley. ‘Razor Edge’ reprinted courtesy of The Marsh Agency Ltd on behalf of the Society of Authors. ‘Holiday Task’ from Murder in Miniature by Leo Bruce reprinted by permission of Peters Fraser & Dunlop (www.petersfraserdunlop.com) on behalf of the Estate of Leo Bruce. ‘Cousin Once Removed’ reproduced with permission of Curtis Brown Group Ltd, London on behalf of the Executors of the M. F. Gilbert Estate. Copyright © Michael Gilbert 1953.")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Published by Poisoned Pen Press in association with the British Library")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("First E-book Edition  2015")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("ISBN: 9781464203763 ebook")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in, or introduced into a retrieval system, or transmitted in any form, or by any means (electronic, mechanical, photocopying, recording, or otherwise) without the prior written permission of both the copyright owner and the publisher of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("The historical characters and events portrayed in this book are inventions of the author or used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Poisoned Pen Press"), _c('br'), _vm._v("6962 E. First Ave., Ste. 103"), _c('br'), _vm._v("Scottsdale, AZ 85251")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright para-style-override-2"
  }, [_c('a', {
    attrs: {
      "href": "http://www.poisonedpenpress.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "Hyperlink",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("www.poisonedpenpress.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_c('a', {
    attrs: {
      "href": "mailto:info%40poisonedpenpress.com?subject="
    }
  }, [_c('span', {
    staticClass: "Hyperlink",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("info@poisonedpenpress.com")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2404c62b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resorting_to_Murder1.vue
// module id = 60
// module chunks = 0